import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'tifs';

export function useGetAllTifs(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetTif(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateTif() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateTif({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteTif({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
